import { useState } from 'react';
import CaseList from './CaseList';
import { PaginatedCaseDto } from 'src/crs/case/service/CaseService';

const CaseListContainer = () => {
  const [casesList, setCasesList] = useState<PaginatedCaseDto | undefined | null>(null);
  const [casesSearchValue, setCasesSearchValue] = useState<string>('');
  const [casesIsLoading, setCasesIsLoading] = useState(true);
  const [casesAssignedTo, setCasesAssignedTo] = useState<any>([]);
  const [caseStatus, setCaseStatus] = useState<string>('');

  return (
    <CaseList
      includeBreadcrumbs={true}
      tableData={casesList}
      setTableData={setCasesList}
      search={casesSearchValue}
      setSearch={setCasesSearchValue}
      isLoading={casesIsLoading}
      setIsLoading={setCasesIsLoading}
      assignedTo={casesAssignedTo}
      setAssignedTo={setCasesAssignedTo}
      caseStatus={caseStatus}
      setCaseStatus={setCaseStatus}
      show={true}
    />
  );
};

export default CaseListContainer;
